import { Button } from "../ui/Button";
import { Banner } from "../ui/Banner";
import type { TokenRow } from "./types";
import type { KeyboardEvent } from "react";

export interface RevokeConfirmDialogProps {
  token: TokenRow | null;
  pending: boolean;
  error: string | null;
  onConfirm: (token: TokenRow) => void;
  onCancel: () => void;
}

export function RevokeConfirmDialog({
  token,
  pending,
  error,
  onConfirm,
  onCancel,
}: RevokeConfirmDialogProps) {
  if (!token) return null;

  function handleKeyDown(e: KeyboardEvent) {
    if (e.key === "Escape") onCancel();
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="revoke-dialog-title"
      className="fixed inset-0 z-overlay flex items-center justify-center bg-black/60"
      onKeyDown={handleKeyDown}
    >
      <div className="w-full max-w-sm rounded-xl border border-slate-700 bg-slate-900 p-6 shadow-2xl">
        <h2 id="revoke-dialog-title" className="mb-3 text-lg font-semibold text-slate-100">
          Revoke {token.name}?
        </h2>
        <p className="mb-4 text-sm text-slate-300">
          Any clients using this token will lose access immediately.
        </p>

        {error && (
          <Banner kind="error" className="mb-4">
            {error}
          </Banner>
        )}

        <div className="flex justify-end gap-2">
          <Button
            variant="ghost"
            autoFocus
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={pending}
            onClick={() => onConfirm(token)}
          >
            {pending ? "Revoking…" : "Revoke"}
          </Button>
        </div>
      </div>
    </div>
  );
}
